import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { CarModel, UserModel, AddressModel, CompanyModel, CoverageModel } from '../models';


@Component({
  selector: 'app-cotizador-auto',
  templateUrl: './cotizador-auto.component.html'
})
export class CotizadorAutoComponent implements OnInit {

  errors: any = [];

  carData: CarModel = new CarModel;
  userData: UserModel = new UserModel;
  addressData: AddressModel = new AddressModel;
  companyData: CompanyModel = new CompanyModel;
  coverageData: CoverageModel = new CoverageModel;

  brands: any = [];
  years: any = null;
  families: any = null;
  models: any = null;
  provinces: any = null;
  localities: any = null;

  channelId: number = 0;


  myCarInfo: string = "";

  step: number = 1;
  isLoading: boolean = false;


  companies: any = [
    { id: 1, nombre: "Allianz", icono: "allianz.png" },
    { id: 6, nombre: "Orbis", icono: "orbis.png" },
    { id: 9, nombre: "Sancor", icono: "sancor.png" }
  ];

  coverages: any = null;
  quotes: any = null;

  slideConfig: any = {
    "slidesToShow": 3,
    "slidesToScroll": 3,
    "infinite": false,
    "arrows": false,
    "dots": true,
    "responsive": [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  constructor(
    private api: ApiService
  ) {

    this.api.getCanales().subscribe(x => {
      this.channelId = x.data[0].id;
    });

    /*
    this.companies.forEach(company => {
      this.api.getCoveragesByCompany(company.id).subscribe(coberturas => {
        company.coberturas = coberturas.data;
      })
    });
    */
   
    this.api.getCoverages().subscribe(coverages => {
      this.coverages = coverages.data;
    });

  }


  selectCoverages(company: any) {

    this.api.getCoveragesByCompany(company.id).subscribe(x => {
      console.log(x);
    });

    this.api.getQuotes(company.nombre, this.carData.car_id).subscribe(x => {
      console.log(x);
    });
  }

  ngOnInit() {
    this.selectBrands();
    this.selectProvinces();
  }

  selectBrands() {
    this.api.getCardBrands().subscribe(x => {
      this.brands = x.data;
    });
    this.carData.year = null;
    this.carData.family_id = null;
    this.carData.model_id = null;
  }

  selectYear() {
    this.carData.year = null;
    this.api.getCardYears(this.carData.brand_id).subscribe(x => {
      this.years = x.data;
    });
    this.carData.family_id = null;
    this.carData.model_id = null;
  }

  selectFamilies() {
    this.carData.family_id = null;
    this.api.getCardFamilies(this.carData.brand_id, this.carData.year).subscribe(x => {
      this.families = x.data;
    });
    this.carData.model_id = null;
  }

  selectModels() {
    this.api.getCardModels(this.carData.brand_id, this.carData.year, this.carData.family_id).subscribe(x => {
      this.models = x.data;
    });
  }

  selectProvinces() {
    this.provinces = [
      { id: 24, nombre: "CAPITAL FEDERAL", pais_id: 1 },
      { id: 1, nombre: "BUENOS AIRES", pais_id: 1 },
      { id: 2, nombre: "CATAMARCA", pais_id: 1 },
      { id: 3, nombre: "CHACO", pais_id: 1 },
      { id: 4, nombre: "CHUBUT", pais_id: 1 },
      { id: 5, nombre: "CORDOBA", pais_id: 1 },
      { id: 6, nombre: "CORRIENTES", pais_id: 1 },
      { id: 7, nombre: "ENTRE RIOS", pais_id: 1 },
      { id: 8, nombre: "FORMOSA", pais_id: 1 },
      { id: 9, nombre: "JUJUY", pais_id: 1 },
      { id: 10, nombre: "LA PAMPA", pais_id: 1 },
      { id: 11, nombre: "LA RIOJA", pais_id: 1 },
      { id: 12, nombre: "MENDOZA", pais_id: 1 },
      { id: 13, nombre: "MISIONES", pais_id: 1 },
      { id: 14, nombre: "NEUQUEN", pais_id: 1 },
      { id: 15, nombre: "RIO NEGRO", pais_id: 1 },
      { id: 16, nombre: "SALTA", pais_id: 1 },
      { id: 17, nombre: "SAN JUAN", pais_id: 1 },
      { id: 18, nombre: "SAN LUIS", pais_id: 1 },
      { id: 19, nombre: "SANTA CRUZ", pais_id: 1 },
      { id: 20, nombre: "SANTIAGO DEL ESTERO", pais_id: 1 },
      { id: 21, nombre: "TIERRA DEL FUEGO", pais_id: 1 },
      { id: 22, nombre: "TUCUMAN", pais_id: 1 },
      { id: 23, nombre: "SANTA FE", pais_id: 1 }
    ];
    this.localities = null;



  }

  selectLocalities() {
    this.api.getLocalities(this.addressData.province_id).subscribe(x => {
      this.localities = x.data;
      this.localities.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
    });
  }

  updateMyCarInfo() {
    let brandName = this.brands.find(x => x.id === parseInt(this.carData.brand_id)).nombre;
    let familyName = this.families.find(x => x.id === parseInt(this.carData.family_id)).nombre;
    let modelName = this.models.find(x => x.id === parseInt(this.carData.model_id)).nombre;

    this.myCarInfo = brandName + ' ' + this.carData.year + ' ' + familyName + ' ' + modelName;
  }

  goToUserBox() {

    if (this.carData.brand_id && this.carData.family_id && this.carData.model_id && this.carData.year) {
      this.updateMyCarInfo();
      this.step = 2;
    } else {
      alert("Por favor seleccione todos los datos de su auto.");
    }

  }



  selectQuotes() {
    this.api.getQuotes(this.companyData.nombre, this.coverageData.id).subscribe(q => {
      console.log("COTIZACIONES");
      console.log(q.data);
    });
  }

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  quote() {

    let userId: any;

    this.userData.fecha_nacimiento = this.formatDate(this.userData.fecha_nacimiento);

    //creo el usuario
    this.isLoading = true;

    this.api.addUser(this.userData).subscribe(x => {
      userId = x.user.id;

      this.api.addAddress(userId, this.addressData.locality_id).subscribe(ad => {
        //creo el vehiculo
        this.api.addCar(this.carData, userId, this.channelId).subscribe(x => {
          this.carData.car_id = x.data.vehiculo_id;

          //actualizo el usuario
          this.api.updateCar(this.carData, userId, x.data.id).subscribe(x => {
            this.step = 3;
            this.isLoading = false;
          }, err => {
            this.isLoading = false;
            alert("Se produjo un error al enviar su información.");
          });

        }, err => {
          this.isLoading = false;
          alert("Se produjo un error al enviar su información.");
        });

      }, err => {
        this.isLoading = false;
        alert("Se produjo un error al enviar su información geográfica.");
      });

    }, ret => {
      this.errors = ret.error.errors.title;
      this.isLoading = false;
    });

  }

}
